import React from 'react';
import PropTypes from 'prop-types';
import DefaultPicture, { propTypes as picturePropTypes } from '../../../01_atoms/DefaultPicture';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBImageWithCaption = ({
  image,
  imageCaption = '',
  className = '',
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb ${
      styles['bb-image-with-caption']
    } ${className} ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <div className="container">
      <div className="image-wrapper">
        <div className="image-container">
          <DefaultPicture loading="lazy" {...image} />
        </div>

        {imageCaption && <div className={styles['caption']}>{imageCaption}</div>}
      </div>
    </div>
  </div>
);

BBImageWithCaption.propTypes = {
  image: PropTypes.shape(picturePropTypes).isRequired,
  imageCaption: PropTypes.string,
  className: PropTypes.string,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBImageWithCaption;
